import { Modal, ModalProps } from "@arco-design/web-react";

const RefTipModal: React.FC<ModalProps> = (props) => {
  return (
    <Modal {...props} title={"提示"}>
      <p>无法删除</p>
      <p>当前素材已在工程中被引用，可查看关联工程后操作</p>
    </Modal>
  );
};

export default RefTipModal;
